// projects/humanresources-general/src/assets/i18n/*/hr-gen-work-subarea.json
export class HrGenWorkSubareaKey {
    private static readonly keyPrefix = 'hrGenWorkSubarea';
    public static title = `${HrGenWorkSubareaKey.keyPrefix}.title`;
    public static pageHeader = `${HrGenWorkSubareaKey.keyPrefix}.pageHeader`;
    public static workArea = `${HrGenWorkSubareaKey.keyPrefix}.workArea`;
    public static country = `${HrGenWorkSubareaKey.keyPrefix}.country`;
    public static workSubareaText = `${HrGenWorkSubareaKey.keyPrefix}.workSubareaText`;
}
